import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { getCart } from '../api';

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    updateCartCount();
    
    const handleCartUpdate = () => updateCartCount();
    window.addEventListener('cartUpdated', handleCartUpdate);
    
    return () => window.removeEventListener('cartUpdated', handleCartUpdate);
  }, []);

  const updateCartCount = () => {
    const cart = getCart();
    const count = cart.reduce((sum, item) => sum + item.quantity, 0);
    setCartCount(count);
  };

  const scrollToSection = (sectionId) => {
    setIsMenuOpen(false);
    
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        element?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-black/65 backdrop-blur-md z-50 border-b border-white/8">
      <div className="px-[8%] py-5 flex justify-between items-center">
        <Link to="/" className="text-[#ff1f4d] text-3xl font-black tracking-widest hover:opacity-80 transition-opacity">
          2.TURNT
        </Link>

        <nav className={`
          md:flex md:gap-6 md:static md:flex-row md:bg-transparent md:p-0 md:border-none
          ${
            isMenuOpen
              ? 'flex flex-col absolute top-20 right-0 w-56 bg-[#111] p-6 border-l border-white/10'
              : 'hidden'
          }
        `}>
          <button
            onClick={() => scrollToSection('jackets')}
            className="nav-link text-white text-sm uppercase transition-colors hover:text-[#ff1f4d] py-2 md:py-0 text-left"
          >
            Jackets
          </button>
          <button
            onClick={() => scrollToSection('pants')}
            className="nav-link text-white text-sm uppercase transition-colors hover:text-[#ff1f4d] py-2 md:py-0 text-left"
          >
            Pants
          </button>
          <button
            onClick={() => scrollToSection('shorts')}
            className="nav-link text-white text-sm uppercase transition-colors hover:text-[#ff1f4d] py-2 md:py-0 text-left"
          >
            Shorts
          </button>
          <button
            onClick={() => scrollToSection('accessories')}
            className="nav-link text-white text-sm uppercase transition-colors hover:text-[#ff1f4d] py-2 md:py-0 text-left"
          >
            Accessories
          </button>
          <Link
            to="/admin"
            className="nav-link text-white text-sm uppercase transition-colors hover:text-[#ff1f4d] py-2 md:py-0"
            onClick={() => setIsMenuOpen(false)}
          >
            Admin
          </Link>
        </nav>

        <div className="flex items-center gap-4">
          <Button
            onClick={() => navigate('/cart')}
            variant="ghost"
            size="icon"
            className="relative hover:text-[#ff1f4d] transition-colors"
          >
            <ShoppingCart className="h-6 w-6" />
            {cartCount > 0 && (
              <Badge className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 bg-[#ff1f4d] text-white text-xs">
                {cartCount}
              </Badge>
            )}
          </Button>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white text-3xl"
          >
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>
    </header>
  );
};
